import { render } from "./PartPage.vue?vue&type=template&id=5541c14e"
import script from "./PartPage.vue?vue&type=script&lang=js"
export * from "./PartPage.vue?vue&type=script&lang=js"
script.render = render

export default script